import { useStore } from '@nanostores/react';
import Fieldset from '@/components/fieldset';
import { $db } from '@/state/db';
import './style.less';

export default function LeftNav() {
  const store = useStore($db);
  return (
    <div className="left-nav-component">
      <h1>
        <a href="#">
          <span id="logo">SQLite Web Viewer</span> <span id="version">v0.0.1</span>
        </a>
      </h1>
      <div className="tables">
        <Fieldset legend={<b>{store.name}</b>}>
          {store.tables.map((table) => (
            <div className="table" key={table.name}>
              <span>[Table]</span>
              <a href="#">{table.name}</a>
            </div>
          ))}
        </Fieldset>
      </div>
    </div>
  );
}
